export const PercentageDropDown = [
  { id: 0, label: 'All' },
  { id: 1, label: 'Under 50%' },
  { id: 2, label: 'Above 50%' },
  /* { id: 3, label: '20–30%' },
  { id: 4, label: '30–40%' },
  { id: 5, label: '40–50%' },
  { id: 6, label: '50–60%' },
  { id: 7, label: '60–70%' },
  { id: 8, label: '70–80%' },
  { id: 9, label: '80–90%' },
  { id: 10, label: '90–100%' }, */
];
